import { Link2 } from 'lucide-react'
import { hostOf } from '../lib/text'

/** A link card's site line, as the app's link cards show it: a small link icon and the domain. */
export function LinkSite({ url }: { url: string }) {
  return (
    <span className="flex min-w-0 items-center gap-1.5 font-sans text-[12px] font-medium text-muted-foreground">
      <Link2 size={12} aria-hidden className="shrink-0 opacity-70" />
      <span className="truncate">{hostOf(url) || url}</span>
    </span>
  )
}
